export const formatTimeDuration = (defaultDuration: number): string => {
  if (defaultDuration >= 60) {
    return `${defaultDuration / 60}h`;
  }
  return `${defaultDuration}m`;
};
